// src/components/Logo.js
// HomeIQa — Reusable logo component with the gold italic "a" superscript
import React from 'react';

export default function Logo({ size = 'md', dark = false }) {
  const sizes = {
    sm: { wrapper: 18, iq: 18, a: 10 },
    md: { wrapper: 22, iq: 22, a: 12 },
    lg: { wrapper: 30, iq: 30, a: 16 }
  };
  const s = sizes[size] || sizes.md;
  const textColor = dark ? '#4A1220' : 'white';

  return (
    <a href="/" className="homeiqa-logo" style={{ textDecoration: 'none' }}><span style={{
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: s.wrapper,
      fontWeight: 600,
      color: textColor,
      letterSpacing: '-0.3px',
      userSelect: 'none'
    }}>
      Home
      <span style={{ color: '#C9A84C' }}>IQ</span>
      <em style={{
        fontStyle: 'italic',
        color: '#C9A84C',
        fontSize: s.a,
        verticalAlign: 'super',
        letterSpacing: 0,
        fontWeight: 400
      }}>a</em>
    </span></a>
  );
}
